module.exports = __webpack_public_path__ + "img/icon-cykel_dark.1a03d404.png";